export default __webpack_public_path__ + "img/InterDisplay-SemiBold_903a289.woff2";